import {
  useAudioInputs,
  useLogger,
  useMeetingManager,
} from 'amazon-chime-sdk-component-library-react'
import { DeviceInput } from './DeviceInput'

type MicSelectionProps = {
  /** The message that will be shown when no microphone devices are found. */
  notFoundMsg?: string
  /** The label that will be shown for microphone selection, it defaults to `Microphone source`. */
  label?: string
  /** Optional description to help the user understand what they are selecting */
  description?: string
}

export function MicSelection({
  notFoundMsg = 'No microphone devices found',
  label = 'Microphone Source',
  ...props
}: MicSelectionProps) {
  const logger = useLogger()
  const { devices, selectedDevice } = useAudioInputs()
  const meetingManager = useMeetingManager()

  const handleSelect = async (deviceId: string): Promise<void> => {
    try {
      await meetingManager.startAudioInputDevice(deviceId)
    } catch {
      logger.error('MicSelection failed to select mic')
    }
  }

  return (
    <DeviceInput
      {...props}
      devices={devices.filter(({ deviceId }) => !!deviceId)}
      label={label}
      notFoundMsg={notFoundMsg}
      selectedDevice={selectedDevice}
      onChange={handleSelect}
    />
  )
}
